export const contentCartSelector = '.top-menu__item.content-cart-item';
export const v2CartSelector = '.top-navigation__main-menu__item--cart';
export const v3CartSelector = '.top-menu__item.cart-item';